import ContactCard from "./ContactCard";

const ContactCardsSection = () => (
  <section className="py-16 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <ContactCard icon="📞" title="Teléfono">
          <a
            href="tel:+523335781778"
            className="hover:text-brand-primary transition-colors"
          >
            +52 3335 78 17 78
          </a>
        </ContactCard>

        <ContactCard icon="✉️" title="Email">
          <a
            href="mailto:pdrocb@gmail.com"
            className="hover:text-brand-primary transition-colors"
          >
            pdrocb@gmail.com
          </a>
        </ContactCard>

        <ContactCard icon="📍" title="Ubicación">
          Jalisco, México
        </ContactCard>
      </div>
    </div>
  </section>
);

export default ContactCardsSection;
